import { api } from "@/core/api";

export interface MaintenanceStatus {
  maintenance: boolean;
}

/**
 * Client for the stored maintenance-mode flag (issue #2343).
 *
 * `getStatus` is a public, unauthenticated read the app makes on load so it can
 * show the "back soon" page immediately while logins/writes are blocked. There
 * is deliberately no enable/disable here: enabling is an admin-only operational
 * action (POST /api/admin/maintenance/enable) and the undo is an operator
 * running `MaintenanceModeCLI off`.
 */
export const maintenanceService = {
  async getStatus(): Promise<MaintenanceStatus> {
    return api.get<MaintenanceStatus>("/api/maintenance/status");
  },
};
